import { theme } from 'src/features/common/app/components/theme-provider/theme';
import { ButtonProps } from 'src/ui/common/atoms/button/button.types';
import styled, { css, keyframes } from 'styled-components';

const ripple = keyframes`
  to {
    transform: scale(4);
    opacity: 0;
  }
`;

export const noiseMixin = css`
    &::after {
        content: '';
        z-index: 1;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: #e9e9e9
            url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAMAAABHPGVmAAAAVFBMVEUAAAC8vrzc2tykoqT8+vzExsTk4uSsqqzs7uy0trTU0tScmpz8/vzMyszk5uSsrqz08vS8urzU1tScnpz09vTEwsTc3tykpqTs6uy0srTMzsyUlpSvmSPgAAAAAXRSTlMAQObYZgAAAAlwSFlzAAAOxAAADsQBlSsOGwAAGN9JREFUaIEdmleWGzkUQ4s550zuf58N9cfYPp6WRL4AXJT8Ucn2JqnMdWrlPqYhaJKR2iC3Ulb5t4osZLIuc2crpOVvt7RQIfPitZ9bs18kRxYDZbOxvu4l2kke3czk5ijVt5ogucqhu+S21VSs7iONocziJR0x32miEOeIPVU8Tfrlp7jYkzi3cZf842LsTKrl6YUR7xLFziRHKk/eXqMOX879nPLilcSRGFVcl1JOnc+cDk/XNjJGERTJIqVmH4llb0aqsanbsfUtcxzNSTZai+J2zqQE16jP3pSk3iQ9fqJ5xi8PZ6jaLCvhkCjvEHLfQETmabG4eaje6TLVHqX7ptQzdxhd+uCijXApS7eqQ+hphC/iY20zysjVoi4399lArOiROyuaQSFfHYm3qWY63QkvkqRzFG6iiXEHTfxpE3XeQbp0hsERN4liqZdYuGmYzuY2t8nujqp8KR9L/pwirDn1IudB0lB3Xsm0MrsJZtngthyDyHZsdoRYdecxbAl9vPNo2thnPidZHDhi5m1HMnyamuPW8U27jsZJPoJuWJpEinj3M++1edkV7K26295OU76F+16NZnh9cyLh0Fnvr3voGi1rydCubJFtGrLlTfWd6St0MDIkF5WYz8orjGV5VM3SNNEaxWomtsbRaJfhmrnym/smHUdQO3V312F4N+6Hrkps616JgSj9cFUjuGUurV4JlaugNMbJrxhjrvN36CG1HcFWzhiul1S5JZDWRvXxRCcOa2S6UM8WwjDX+KDpUWsts31Tlk9Z4q0QJ/XdhZgnb9GmK8V5n7iFXCvUQKtzGBg6NWPQnMfrSGBYr3mpEKUdzFSimaF7TgSxjbKS7jHYYtgtHYZsLEdFCyFT8DQ5CYoRE+vTn69qhSOCW1mzmrD/w6Dbtgq2p1pzhnyxih5HRIkGC3iVpZdHadXi6U6CucA+bi45l2mkWQqLp5/edKfRdQzxxwS1R/YbTRLTsDx3dM93jze+s1oW6ahr4/eyH65QOJaBszCIS+9GHPVpGlTadIZRXIt5WPzasOyTiUmmjXN8LDq0ZGKLiN1MXNawuZUfKdtKKb4WJjZZhMIWXvo2Z+0tQQjXWteCVZLErNXfSMuYdI1CP3behRg+oWBrpP4+dzPHD/C72ZLVK6hE8u6pS0lM+A2rexTfEAIpyF69740F0C7G6G/tiurCpGCJCnt02SdAbBJU00JxCMvLxaW+uY/WMnHX5vGpiZwsXRr/QSAHVYqUuMvt3NPY1FL2Sk3FCryUXJXlzBfjh90PEozGQ9Lo0Lt5mXQmSqYQIWNfjT4zraRtOlVs/1BevTwmLjMtpXapgK1a+93uyDMUsntUoLKPfTOmJJpeSCcwgjt5MFsndXdTFcP/eGq58dq+wrBhK0yo6ZlS0kvQ+RhpazwMdQpv2Mw8QlFVLC10elnMpDR2d7Dn4qNqu+Z3xGWst6Ky6aZNmtTLq5l9Tyq+/fvr7SdT+AG14UXvmpwqTUYRSavzkvGXw707FgF7yKHx1juXcjBXiTslWXe2EUlgYY+wUFKdI3WBxfVr9K7f1Qe7s+rmXEHq3K1EujpiF5Eekz2k6i6N4zGZktvRbtv1veZI26cxPrIRWNm5nSJFmB2W4ijUxaQeAsGf1SIfSntjC88qeGOUUk+JFxpPaupQkD5PueMSzJ/BLZYLpFc73Co+aq57pT5B96AZpbbewsgG/nNz4PG0XPvyccdPGteDgLOgHJXVuSzR2hqS3WUsO6tSKbxSFTKWRAjfNDNyilDh7ZAUSFxXnTIab0+FSOt5Q3WPpi6qTQaE4uWvMcjU8XXkeeUNbYmkzc7SE58gsifZjv2ShLuc6yCtnJteLKzRbbQMDBPNqTfUtDglOw1rWLlZlw3fKKndcpM+FPfig+1UFapIKLYAK6FfUQxVhSCxdRo8mIe7L9M7th24OWcumnFFlMFl7jUunY6yD0aTfQG67Fq8N6E11+0HAoAQwlysgkzdB8M5Cysj+BHbXarkkp5iFA48IMgV2U2CQaJ8cXmr7Gfk2H5Ir4ZEWN7V2zYzhjEAGsFEE6efYNTRWqRv44XbHz7UoKNy4dRWLzWrtGdnOxj8Ki1rbob1FTktW15ZAMxV6hIbE0lWYU4gmSAXXomFlbVgatDfY8swctcVEOYyiQB7NZKbt7qKMiZU8VcwEVLhSeQSqnIlYgNWg9nPIww2FuZK8PkwNMMg6IyJEcJUpeX0bOdfPqO88LL1gpN5B2Pn8OYPmqqvsFrCkp9pIsoHZ0n2QNxOiJh7DkOmauIHeSQ2TDa5sWUbr4ArMyyPBlxO7UtfHSw+EbA5moPZWoNXGPtUuskR18rlRA9TO2asnUQ8HJcS6zPeNI+8RzVnFnvHEv5dDGDsqxJggqKUbD11cYZ8hxtaYNTFrUHJvS6x7TiYdiirLRl0+dL3HXPnW0O5lJse/ewJvLpybyxVlEbreIwoDPdafN0GaeVG0tglJe9+UYuwYn4inw082xh7JWIW/ElAyY26FaxGYDPQq4gRt84hfQHGwF0aabL0Uj27DgI8W60bWgca0evAYrS/QdjwQSzJWFaPI5ZgUKicrU3TAoRoj2W0mI6BU4qkyEhZqJvqBur4rGRwNhWlsSHFb0vDfCvnSMwwMH+BFgLsshYdVB8c1XGlCKUsIywoJnUaCg+FMOhoUZgSqEZpYneI1jzXcXHP/Zn5Dl3CNzD3a2G+gLYa2r6IUWUnlI/uWXP9+A09KTDHoo/hTXgs8Hbh3AwpOG2hOo6bLBy4TiMP2FiFpdtj5cl1Cxu0X/bc77ZtTeJBKANxNJ3ls51+09rZB8dXshlgnELZO64tXOUWuEhceN2Cs85a10dSPfm5M6t2SS4jpIQOQgW0Ghgzzes0PAQqbbO/MhNtxewd8OXF59OuMiQw8DxnCaHJPDYwv4ZiVp2sshgNKmZJ128OfdeOst6ba6iBNzScX9L0VAmSaSc8yDYY19EbYBcBP8Peb8754L2+iP/Ge94xj+LmuwGUxFQ6okW+ksp1AoSRacPNHMz9pIbgMsawIMYLm8WAt5wljjhwasKTJaBzOfP8MCR3OG9+8SMiCr6AIRYZXGqxDIa+qej07YBBgHjc9QPcspgsNjB3e/Q6KWn7F7i2d0MLQfqLZEpj9SzZCqDQ1ynRhdgbnw8b2OEVOaI5S3mnomzmYmsgXArLNCs9UKbMjOpf3NAg21jUeUhDpLoTBrAIbgttvGxHv8Blwo4LFV4EqHI6smHJ8DEMT0W5dIlO6SxBTYspTsx8rWV4e7n1VB/Kz3nVAJ6GAdy2BcGVPOFW1ZAWbwjAcUARyrLCf4aiYBRKqhHI+iWg3AnfA0+FcYJml/ERMlmwWAOzSsxlCXTXoG7oFTaxM/FwXNDsRZBQviYHNQKF64F2IBOE+J26mK3TUSm7QdCuFvPwiwU//IM/XrCOrggxXBJNX44QaREI6kEYYr/bvQPX0OEO+x3yAVhDEE3p1JD1DlS5lC9iU/3CZEcgbEdyUMIfbsu7wDlzOu8MvrxhFau2IHrYlCJxx3V2DVmBgBc5t0/ulIBiBuG8GucQJOX1DKhzSfGlmlGlkuM1Rq4AGiZYvt5kxTubssypv4TA3qMcjgsqNvHSQMpN5PqSn6JKWwfRJbmrtdGYFXXEuBgZQmhyqvNRHkAEKLcLinjC543LKRXjuTBWbF4q7NGJIPE6Lz0rRMJRNpFbFaoH4Wr//EoSHMcspHHLV2Mb6sa0/A28oOc7yhFxVN4ANNeHCHb7xPABvB+AqBR7T+EEQCIGeyrmHoAA9AQjqZ1H57F6zhfEc5o6ihHMHscHmNQA7sx7mZ9PUQFJIr/p3vlQD5cfP/SwMhRg4WRoyCwrCHWYoRVjFg9NdzvlweoyD2jmYUnVqJc0aK9tl2DrhZRs5h5UdeMjBbYvMKc9aWGm8r1RvNntnaq68omRS60GmkMQvRB8aH7VRtAxASY45AosID516YYZHKYMPXPWxYZKiPYEWWt9g1NyMPym6P2bsnO1mh0aAwR/8zlsYlYPshQQNdkqJApG+Pgx05AD1IkEU3dDxoUTIL7AQ4RDBPDYXdtWfibbT/TnkTs8Q/64aIMCf/y01XJs3KqOLT4T0NcSOJcwospuA0hzE4QIu8YAADWvN5VC7UmCCD6OVwRU59CKzERW/bZjZbpzKGE2MsgexoAjXbtheo7RFAccmK5G1XM4dogO25a6cnlWKEIb6VyCbWwittyAYsiPBQxI+baBiBl66AexhXe22HngoE5QShqbnhCWewFd9JJnluQpCMvArIZJN8xHs0iU2iMpKEymtUgUPt+yVj2xDUio3XHONALQIn9ey3j4nRfzLQmWGDFrYdHappq1ToTXhyB7o6V0CeSYUau9hADeTon5kDMSkw0w2CZgDjSuEXCPATLw7lj1OMYXw/GnOnNXabAYQDvlQHj0o4tHe0nENHi7QB7NiLq/jJYqMvhUD+BY7DgSyoSpRKx5tjIvgCzJtmDFL5RVuD/KBUiYXc4VKq+RcTFqbFwc404SBtlhzh2WkA7DDBbqAJpfObHOEZCZ4ibYZr+RRA6J4DxkAvR8R5Xg5XlEutP4IluEhV2XaQsTevPOiOhemOOyOCkDcHAIEyt2ToLs5pYupARHqdpT6J1skjtm2tSxxavKrM0x1MTyXd6QDJz0PWR4YybvMnHEcf/0uoYj9e1bF49D7TIqQbKn0nuRCJIyWa/cLa3N5MVeZeSDWLFtMZMG7uwq4zAZy6ZIXkjo5CNwZeQpC3Wu2mAvg0PlgCXMFuZ1b6528uA5qnmalyKQ15fu70HDgSqbpFrI3nBsjEQIZr3bdAOdpx+GAIIxm+QrwGfvEUi20mHtCqpfErtYmLCR0qfP6prPWhPnu3OOFEBZQtQ7vMTOCtfG0NmMFcKFm20Uirx9ajU13+wwHqZ9QPIC0+dWFQXGU40huPTaK0Nex6t0rTTOZKl+TLNFG0obSAY6NogkmKT5JJeh6/Jn43uXLBqZu+GsYrynI5/yWcBADdcVZHZz6cPUC4N0iArstdZuJWTc/DZsI9Pk9/TZG4kYVqA3TUH2z9bPLEDHPlNzvCtR2hThdmrnWOSN9OF+oZ7OcDcxCn8hPFl4mUlSXccAT+GUzNW5NY92Vusizb9nBNjA9kJjj/yCDz3TuYKAiFwkry2yBT6RX6mISX0qsVIzifAdk06qywMKDdg2wT4F9x1BNXYXQIOq2Uzb0Ej4ry0dwfwBhjA7oDbC1rRIkpnCEVWewUegmUCO0fvHMGh19IkkUbyx0pXSVjz9IeeEQh6urJma3ocR3KBVTzrqLP6cCFfRjSpIvp2aPcienaVgTcSMS9aUk2xF+w2CdNTkQIPszzVMcBpYY7kfMT7295CHdOs7NqRRsnJzw3Mq3SoMLTtoDLSB9FOhMa1Tf2cnJwVLszlwuwXIX9iTW+UeEani/XY0GHt1U6bjf4sJn3VACwwa49aMqpE1QODMb6SmG41hxgLLpcuvbTTu1nqddbzJBnT0IhaNhh37qYl2GoGg0AfEwhT4FgcLCQa0QPRWeH2MBM2JGwVvkF1nkJEAJtEz4OvyqiocBaY9yiUFMceKgLzWqAV8SEzqZzR2mjadi3WSK3yykHCxBVGWSL/ZP4KobU42oTKVQ367nDjuMZh5DpMxCUMg1Rgv0mPFmRaJDsksrBX8mn3Z8+2GCbV5651BcStRSN2cbq59TPBHWWhlTF6Jhhhnmbdoc0ZXaa5Fs4OaBc8Vt5hA9XvmxjSOiXDitEJV/X9s+9yGH7O2LPw8O1ILojcuo1m8S9oEyHsm1W6ocu65mXChQpFHOnT+pt9XXY8C6LJI9SCQT8U94oegUc1KkBzy6/qDlM8UMDkmx2rW71q6ugC7ecBuOOipuuWx4Z00Z+NZQEThw3eHfUMlMU+eD6TIXCIoyNv1e4qUhMLbkOYHtSl98yESznBnlE8HsESnoGbCpQBMKlyoJ4qX/QwWeFa5k8wHoHsFQQNmS53g2OYWRxqIyIUkrgiAJZ1xAoHdHE1B0lIDy5/PrN1VFXpRQfqiEH0mWQHhJ+AM9MBAYurUVtsJWvvWXtv+xFq9g+6tt0yRL7CrgVoLLihFw7JLRJX8CUh3wKuRoJ4cjd0ns1utG6jok/wUUkqR/DG7HkejCEV+2EsurjxSHGITCqcmAnxIzzZiGALrAm1fb6+fP5pun1qgEZYp9XAicNJpU3QPSu+Yp838Qb7s7kKVIjNgA4k8Nm96VZZRggVZSBk0PD+FBDwgA9atM8j6jsUasGWK9BEbosvI4E37JiHUa03ReNmgIQEVuybytM0TIg2P3gzye3CGEIR+J4h84ku5V2NgSMBQ/5s2Y2hwEAA4pkHBW36NUYDbSrkJR6YNkEU5kL5eqK8quwTBGeVJyCu43oAX0B4cB6ZU1zcDCw/vq9+41D3awZHqNKNhxiKj9wmiZP92pkX2nJQYVsFjsEPQ6ZpSLdcMTOLxdvODCOLkOmLxxBiZKfLgfStW20Pz7O9Ct0CkeVTVBouzSrD/G1U0hLTPd9pnS0+5cpdJPXcAbT1+G1NgCzNf94AQaXdDrhbqkt2QDgWvjJoN6UxrnQsJ6eHWvRCXjqXFKeqRQ2GvoUj51aDrWtGmvTqYA4F1MGRLojylLDuNWmiwRZQVaJS38w00ofDn37diLjWLN5fTPjHFoaEGKSOrTmSERU77Aslo/o1aZrEWHwuk1Wj5nX7g0BPBWmun+/o9gg4ddLu6LOU8mJu1lsw6aR/0IUhGAomCmTqi4bp5wmClBPXbfu20BSwMvTdGdwtCk0YhDwyzfl/P/RKECug4NtmVwOGKndcQlaaIrtKkiVxvW0W8faqwO2Zqpfe0+vGObmHp72DOc9G/B24/z+sRu08ZTrVOaKpRyX1mhWVLIYfycWLb73RYWnAGi2mupe9BIlnqnAU3upQCsyq/buqAAB/k1ZxrDaT9CiMkvyS7SmIhkSeyBZGsNu4XdKBxZmciFExwHBbBSrHWgLmbZGcYDjE5UR+XLsjH2d65iH+7SRdvqg0rhAr1DwnITVIZ0eMCWAlgniE5u9DqAXvyKVXKCLobdC5iV70TwpnjsAf3+NyR7IvRh+hSKFDvSDlMLkDA1SCbjI7p9d2RhOYO+GHac4g3STTT58SnAopRaMcoGSWBwyuCPTIav4cgVHbeWD/DGePhtyuyd5hoEQmTqqAY7JkMwe4Ue396h7ABcQ0L43Ccppe4RFEk/uRWurhjFHEFlzbCAUkV7qTN/rl2kpNsiHHiA4CCBLMPwqbVzkqZ4HEK0hsL7v+5TFIj8g0MbulqKo2eTFWEuMdjcyw0cGdw8YER3lhujCkUDgE1qdRTB/pdhGSuKT4u10NhIGeFYhHceWdEGwqpbxzxcleFaHZzgBfSoVbTLisC5wC7HVVtlJfAjTcqup7CWwIaIrqvmOH5+d+Thj4U2JL1iOwINbWhL+GWiip+ZnO9QiNraH0RpxSywG1ZBjC8gtBykNo05ZUa3SX29+1I5sHUpieTCImiQj/BjQGir7USWmTGbr7qV7kG1p2SfVXVtb3U0ideXMUGsN8D0msUrvwMkxnJe8UepCIZcKmozpanJCXvrbU+HhOFiPLb4e1VsslFFiMSAl8+qCXvXt+G2pSziZRb39TgPFtx4uXKkczL60Xc50lBuxB+PWyQlf5SiB5ykQ4k/O7fY7WFkoKwTtEJgWrYXooyera9Ea+/hFWny97fF1pMlfz/7xeoe7AQCm9CKozrYeR2Zcy6cW173Y2m67MaLLm377b11zEUo4GpEY9jGndmhcTl4h766A+m3B23BAVaAnMJPTXnIe/DyWXwzV2kCOaxWuXeM2iBzkMiKklJ7KAlRYJ7oLBIA6NDZ3GzJC/p0HSBa7BKtv10979/CDPla8g83WhCC4pkj4Z1tNguiKeIgC0yc+Qtc1Qj/CQcp8dK6cA3YS2E5GQh/nIfMe52IcFMsE7oLQj6cXTzBGNIOsPfzqDAesO8iwKQTUUlm+rSagHLUYj9MtYE4dBlfnIHNEeSswRx/fq668zYNXBbZb+UvoQYjmcJuDNg6zDlaWCfKq/rYxuc7IJKKOy1Ip8+LAaGW2H7QEhLpM1rRKayZgc4d5rFYAt+vpbhpJmvoEgJvsDkKBL9t4TnkDQ+BfQ1+QY30nDw2ttDw3GMp1d38INq5LtHHBGNt3GAefYATOBjfwDSBV+IPVyJCUHhTSDi94w0HGVJX92kaU7E71kNnd76uRiHPMHtQ5wIg4RWZ1IgQKGYsHpSMTuYrRmRpcDzZx8V1rCJfm0Uv6F5yKoPOzQy6BueH7+SKhD1wEhOsvJA4uOBykJSyalzHOFhg2y4BgCT+vfokebBR6EAhtC3Bk0s/AV1EK9kWr6zJgw5zKh1T9qGEd6vA9mqFWK1RKzbFYUxedhcxfC1lew2Imr8GS9L19aoQK4iHsgF86NUdqo1KGJjYSZh+lk71lWv6lpL266DTps/v+MbXwDJ9KYAAAAASUVORK5CYII=);
        opacity: 0.1;
    }

    @keyframes noise {
        0%,
        100% {
            background-position: 0 0;
        }
        10% {
            background-position: -5% -10%;
        }
        20% {
            background-position: -15% 5%;
        }
        30% {
            background-position: 7% -25%;
        }
        40% {
            background-position: 20% 25%;
        }
        50% {
            background-position: -25% 10%;
        }
        60% {
            background-position: 15% 5%;
        }
        70% {
            background-position: 0% 15%;
        }
        80% {
            background-position: 25% 35%;
        }
        90% {
            background-position: -10% 10%;
        }
    }
`;

export const StyledButton = styled.button<ButtonProps>`
    user-select: none;
    cursor: pointer;
    position: relative;
    font-size: 14px;
    line-height: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: fit-content;
    border-radius: 5px;
    border: none;
    font-family: ${({ theme }) => theme.fonts.text};
    font-weight: 400;
    transition: background 400ms;
    overflow: hidden;

    span.ripple {
        position: absolute;
        border-radius: 50%;
        transform: scale(0);
        animation: ${ripple} 600ms linear;
    }

    ${(props) =>
        props.stretch &&
        `
    width: 100%;
  `};

    ${(props) =>
        props.size === 'sm' &&
        `
    height: 30px;
    padding: 0 10px;
  `};

    ${(props) =>
        props.size === 'md' &&
        `
    height: 40px;
    padding: 0 11px;
  `};

    ${(props) =>
        props.size === 'lg' &&
        `
    height: 50px;
    padding: 0 20px;
  `};

    ${(props) =>
        props.disabled &&
        `
    cursor: not-allowed;
    pointer-events: none;
  `};

    ${(props) =>
        props.variant === 'white' &&
        `
    background: ${props.theme.colors.text};
    color: ${props.theme.colors.warmBlack};

    span.ripple {
      background-color: #9747FF;
      opacity: 15%;
    }
  `};

    ${(props) =>
        props.variant === 'white' &&
        props.disabled &&
        `
    color: rgba(${theme.colors.warmBlackRgb}, 0.5);
  `};

    ${(props) =>
        props.variant === 'whiteRounded' &&
        `
    background: ${props.theme.colors.text};
    color: ${props.theme.colors.warmBlack};
    border-radius: 50px;

    span.ripple {
      background-color: #9747FF;
      opacity: 15%;
    }
  `};

    ${(props) =>
        props.variant === 'pink' &&
        `
    background: ${props.theme.colors.pink500};
    color: ${props.theme.colors.warmBlack};

    span.ripple {
      background-color: ${props.theme.colors.text};
      opacity: 30%;
    }
  `};

    ${(props) =>
        props.variant === 'pink' &&
        props.disabled &&
        `
    color: rgba(${theme.colors.warmBlackRgb}, 0.5);
  `};

    ${(props) =>
        props.variant === 'gradient' &&
        `
    color: ${props.theme.colors.white};
    background: none;
    ${noiseMixin};
  `};

    ${(props) =>
        props.variant === 'gradient' &&
        props.disabled &&
        `
    color: rgba(${theme.colors.warmBlackRgb}, 0.5);
  `};

    ${(props) =>
        props.variant === 'rounded' &&
        `
          color: ${theme.colors.white};
          font-weight: 700;
          padding: 10px 34px;
          border-radius: 50px;
          box-shadow: 0 0 6px 0 rgba(157, 96, 212, 0.5);
          border: solid 2px transparent;
          background-image: linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 0)), linear-gradient(101deg, #78e4ff, #1C60FA);;
          background-origin: border-box;
          background-clip: content-box, border-box;
          box-shadow: 2px 1000px 1px rgb(50, 48, 49) inset;
      
          &:hover {
            box-shadow: none;
            color: rgb(50, 48, 49);
          }
    
  `};

    ${(props) =>
        props.variant === 'roundedInverse' &&
        `
          color: ${theme.colors.white};
          font-weight: 700;
          padding: 10px 34px!important;
          border-radius: 50px;
          border: solid 2px transparent;
          box-shadow: none;
          color: rgb(50, 48, 49);
          background-image: linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 0)), linear-gradient(101deg, #78e4ff, #1C60FA);;
          background-origin: border-box;
          background-clip: content-box, border-box;
    
        &:hover {
          color: ${theme.colors.white};
          box-shadow: 0 0 6px 0 rgba(157, 96, 212, 0.5);
          box-shadow: 2px 1000px 1px rgb(50, 48, 49) inset;
        }
    
  `};

    ${(props) =>
        props.variant === 'grey' &&
        `
    background: ${props.theme.colors.gs500};
    color: ${props.theme.colors.text};

    span.ripple {
      background-color: ${props.theme.colors.text};
      opacity: 8%;
    }
  `};

    ${(props) =>
        props.variant === 'grey' &&
        props.disabled &&
        `
    color: rgba(${theme.colors.textRgb}, 0.5);
  `};

    ${(props) =>
        props.variant === 'outline' &&
        `
    background: ${props.theme.colors.warmBlack};
    color: ${props.theme.colors.text};
    border: 1px solid ${props.theme.colors.gs300};

    span.ripple {
      background-color: ${props.theme.colors.text};
      opacity: 8%;
    }
  `};

    ${(props) =>
        props.variant === 'outlineRounded' &&
        `
    background: ${props.theme.colors.warmBlack};
    color: ${props.theme.colors.text};
    border: 1px solid ${props.theme.colors.gs300};
    border-radius: 50px;

    span.ripple {
      background-color: ${props.theme.colors.text};
      opacity: 8%;
    }
  `};

    ${(props) =>
        props.variant === 'outline' &&
        props.disabled &&
        `
    color: rgba(${theme.colors.textRgb}, 0.5);
  `};

    ${(props) =>
        props.variant === 'blue' &&
        `
    background: ${props.theme.colors.blue600};
    color: ${props.theme.colors.text};

    span.ripple {
      background-color: ${props.theme.colors.text};
      opacity: 8%;
    }
  `};

    ${(props) =>
        props.variant === 'blue' &&
        props.disabled &&
        `
    color: rgba(${theme.colors.textRgb}, 0.5);
  `};

    ${(props) =>
        props.variant === 'none' &&
        `
    color: ${props.theme.colors.text};
    background: transparent;
    height: auto;
    padding: 0;

    span.ripple {
      background-color: ${props.theme.colors.text};
      opacity: 8%;
    }
  `};

    ${(props) =>
        props.variant === 'none' &&
        props.disabled &&
        `
        color: rgba(${theme.colors.textRgb}, 0.5);
  `};

    //******* OCEAN TEMPLATE

    ${(props) =>
        props.variant === 'blueBorder' &&
        `
        color: ${props.theme.colors.black};
        box-shadow: rgba(45, 35, 66, 0.4) 0 2px 4px,rgba(45, 35, 66, 0.3) 0 7px 13px -3px,${props.theme.colors.blue} 0 -3px 0 inset;
        background: white;
        transition: all .3s;
        border-radius: 0;
        
        &:hover {
              color: ${theme.colors.white};
              background: ${props.theme.colors.blue};
              border: none;
            }
  `};

    ${(props) =>
        props.variant === 'o_white' &&
        `
      color: ${props.theme.colors.black};
      background: ${theme.colors.white};
      transition: all .3s;
      border-radius: 0;
      border:1px solid ${props.theme.colors.softBlue};
      
      &:hover {
            color: ${theme.colors.white};
            background: ${props.theme.colors.softBlue};
          }
  `};

    ${(props) =>
        props.variant === 'o_blue' &&
        `
      color: ${props.theme.colors.white};
      background: ${props.theme.colors.blue};
      border-radius: 0;
      transition: all .3s;
      
      &:hover {
            background: ${props.theme.colors.deepBlue};
          }
  `};

    ${(props) =>
        props.variant === 'o_purple' &&
        `
      color: ${props.theme.colors.white};
      background: ${theme.colors.purple};
      border-radius: 0;
      transition: all .3s;
      
      &:hover {
            background: ${props.theme.colors.softPurple};
            color: ${props.theme.colors.black};
          }
  `};
`;

export const StyledCanvas = styled.canvas`
    position: absolute;
    z-index: 0;
    width: 100%;
    height: 100%;
    border-radius: 5px;
`;

export const StyledChildren = styled.div`
    position: relative;
    z-index: 1;
`;